import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Component from './component'
import { submit } from '../../redux/modules/downloadExpose'

const WithData = connect(
  state => ({
    error: state.downloadExpose.error,
    success: state.downloadExpose.success,
  }),
  dispatch => bindActionCreators({ submit }, dispatch)
)(Component)

export default WithData
